export default __webpack_public_path__ + "static/media/hero.a30af0ab.jpg";